<sui-toolbar>
  <ng-container *ngFor="let button of buttons">
    <sui-button
      *ngIf="button.shouldDisplay === undefined || button.shouldDisplay"
      [variant]="button.variant || 'secondary'"
      [leadingIcon]="button.leadingIcon"
      [iconOnly]="!button.label"
      [ariaLabel]="!button.label ? button.tooltip : undefined"
      [suiTooltip]="button.tooltip"
      [loading]="button.loading"
      [disabled]="!button.disabled === undefined || button.disabled"
      (click)="button.action()"
    >
      {{ button.label }}
    </sui-button>
  </ng-container>
</sui-toolbar>
